"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.operation = exports.market = exports.product = exports.purchase = exports.labelList = exports.partingLine = void 0;
exports.partingLine = [160, 380, 580];
exports.labelList = [
    {
        y: 60,
        label: "采购",
    },
    {
        y: 260,
        label: "生产制造",
    },
    {
        y: 460,
        label: "销售",
    },
    {
        y: 660,
        label: "运营运维",
    },
];
//采购流程
exports.purchase = [
    {
        label: "采购合同",
        usable: false,
    },
    {
        label: "采购订单",
        usable: false,
    },
    {
        label: "发货",
        usable: false,
    },
    {
        label: "签收",
        usable: false,
    },
    {
        label: "来料质检",
        usable: false,
    },
    {
        label: "入库",
        usable: false,
    },
    {
        label: "结算",
        usable: false,
    },
];
//生产制造
exports.product = [
    {
        label: "生产计划",
        usable: true,
    },
    {
        label: "备料",
        usable: false,
    },
    {
        label: "领料",
        usable: false,
    },
    {
        label: "投产",
        usable: true,
    },
    {
        label: "过程质检",
        usable: true,
    },
    {
        label: "待组装上架",
        usable: false,
    },
    {
        label: "待老化上架",
        usable: false,
    },
    {
        label: "成品质检",
        usable: false,
    },
    {
        label: "待打包",
        usable: false,
    },
    {
        label: "入短驳库",
        usable: false,
    },
    {
        label: "入成品库",
        usable: true,
    },
];
//销售
exports.market = [
    {
        label: "销售合同",
        usable: true,
    },
    {
        label: "销售订单",
        usable: true,
    },
    {
        label: "MTSMTOETO",
        shape: "square",
        usable: false,
    },
    {
        label: "备货",
        usable: true,
    },
    {
        label: "发货",
        usable: true,
    },
    {
        label: "中转仓库",
        usable: true,
    },
    {
        label: "签收",
        usable: true,
    },
    {
        label: "结算",
        usable: false,
    },
];
//运营运维
exports.operation = [
    {
        label: "安装",
        usable: true,
    },
    {
        label: "调试",
        usable: false,
    },
    {
        label: "质保激活",
        usable: false,
    },
    {
        label: "验收",
        usable: true,
    },
    {
        label: "自营",
        shape: "square",
        usable: false,
    },
    {
        label: "设备上线",
        usable: true,
    },
    {
        label: "资产转固",
        usable: false,
    },
    {
        label: "巡检记录",
        usable: false,
    },
    {
        label: "故障维修记录",
        usable: true,
    },
];
